import * as XLSX from "xlsx";

/**
 * Reads the first sheet of a CSV / XLS / XLSX file into row objects.
 * Header names are lower-cased, trimmed and spaces -> "_" so "Product Code" == "product_code".
 * Cell values come back as strings (what the user sees in the sheet).
 */
export async function readSpreadsheetRows(file) {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: "array" });
  const sheet = wb.Sheets[wb.SheetNames[0]];
  if (!sheet) return [];
  const raw = XLSX.utils.sheet_to_json(sheet, { defval: "", raw: false });
  return raw.map((r) => {
    const out = {};
    Object.entries(r).forEach(([k, v]) => {
      out[String(k).toLowerCase().trim().replace(/\s+/g, "_")] = typeof v === "string" ? v.trim() : v;
    });
    return out;
  });
}

const csvCell = (v) => {
  const s = v === null || v === undefined ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** Downloads a CSV built from a header array and an array of row arrays. */
export function downloadCsvFile(filename, headers, rows) {
  const csv = [headers, ...rows].map((r) => r.map(csvCell).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
